<template>
    <div class="p-1">
        <div class="form-group mb-3">
            <label for="max_gifs">Número de gifs</label>
            <input
                name="max_gifs"
                id="max_gifs"
                class="form-control"
                type="number"
                :min="1"
                :step="1"
                v-model="limit.max_gifs"
            />
        </div>
        <div class="form-group mb-3">
            <label for="max_upload_size">Tamanho máximo de gifs (em Mb)</label>
            <input
                class="form-control"
                name="max_upload_size"
                id="max_upload_size"
                type="number"
                :min="3"
                :step="0.1"
                v-model="limit.max_upload_size"
            />
        </div>
        <button class="btn btn-primary" @click="setLimit">
            Atualizar limites
        </button>
    </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
export default {
    name: "GifsLimitComponent",
    props: {
        userId: Number,
    },
    data() {
        return {
            limit: {
                user_id: 0,
                max_gifs: 1,
                max_upload_size: 3,
            },
        };
    },
    async created() {
        this.SET_LOADING(true);
        await this.getLimit(this.userId);
        this.SET_LOADING(false);
    },
    methods: {
        ...mapActions(["get", "post"]),
        ...mapMutations(["SET_LOADING"]),
        async getLimit(id) {
            const res = await this.get({
                url: `admin/users-gifs/limits/${id}`,
            });
            if (res.status == 200) {
                const limit = res.data.gifs_limit;

                this.limit.max_gifs = limit.max_gifs;
                this.limit.max_upload_size = limit.max_upload_size / 1024;
                this.limit.user_id = limit.user_id;
                console.log(res.data);
            } else {
                alert("Error");
                console.log(res);
            }
        },

        async setLimit() {
            this.SET_LOADING(true);
            const res = await this.post({
                url: `admin/users-gifs/limits/${this.limit.user_id}`,
                data: {
                    max_gifs: this.limit.max_gifs,
                    max_upload_size: this.limit.max_upload_size * 1024,
                },
            });
            if (res.status == 200) {
                const limit = res.data.gifs_limit;

                this.limit.max_gifs = limit.max_gifs;
                this.limit.max_upload_size = limit.max_upload_size / 1024;
                this.limit.user_id = limit.user_id;
                console.log(res.data);

                alert("Limites atualizados");
            } else {
                alert("Error");
                console.log(res);
            }
            this.SET_LOADING(false);
        },
    },
};
</script>
